import {request} from '@/helpers/apiClient';
import {PRODUCTS_CONFIG} from '@/utils/constants/apiConfig/productsConfig';
import {createRequestGate} from '@/helpers/requestGate';

const productListGate = createRequestGate({ttlMs: 10 * 1000});

export const getProductList = (queryParams, searchArr) => {
  const normalisedSearchArr = Array.isArray(searchArr)
    ? searchArr
    : searchArr
      ? [searchArr]
      : [];
  const key = `${String(queryParams || '')}::${JSON.stringify(normalisedSearchArr)}`;

  return productListGate({
    key,
    fetcher: async () =>
      request(PRODUCTS_CONFIG.PRODUCT_LIST(queryParams), {
        data: normalisedSearchArr
      })
  });
};

export const getProductCsvFile = (body, queryParams) =>
  request(PRODUCTS_CONFIG.PRODUCT_CSV_DOWNLOAD(queryParams), {data: body});
